"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_native_1 = require("react-native");
const theme_1 = __importDefault(require("../../styles/theme"));
const constants_1 = require("../../constants/constants");
const styles = react_native_1.StyleSheet.create({
    boxContainer: {
        flexDirection: 'column',
        marginVertical: 20,
        paddingVertical: 10,
        width: '100%',
        alignSelf: 'center',
        borderRadius: 16,
        paddingHorizontal: 7,
        backgroundColor: theme_1.default.colors.COLOR_WHITE,
        maxWidth: 750,
    },
    content: {
        justifyContent: 'center',
        alignItems: 'center',
        paddingVertical: 10,
    },
    textContent: {
        justifyContent: 'flex-start',
        marginHorizontal: 10,
        marginBottom: 10,
    },
    boxButton: {
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 40,
        maxHeight: 45,
        width: 160,
        marginHorizontal: 10,
        backgroundColor: theme_1.default.colors.COLOR_PRIMARY,
        borderRadius: 8,
    },
    errorMessageText: {
        bottom: 15,
        marginTop: 0,
        paddingTop: 0,
    },
    errorMessageFont: {
        fontFamily: constants_1.FONT_FAMILY,
        fontSize: react_native_1.Platform.OS === 'web' ? 13 : 10,
        fontWeight: 'normal',
        letterSpacing: 0.25,
        marginTop: 6,
    },
    text: {
        color: theme_1.default.colors.COLOR_WHITE,
        fontSize: 14,
        fontWeight: 'bold',
    },
    imageSize: {
        width: 230,
        height: 170,
        resizeMode: 'cover',
    },
});
exports.default = styles;
